import Vue from 'vue'
import App from './App.vue'

import '@/assets/css/tailwind.css'

window.axios = require('axios');
window.axios.defaults.headers.post['Access-Control-Allow-Origin'] = '*';

Vue.config.productionTip = false


import router from './router';
new Vue({
  render: h => h(App),
  router
}).$mount('#app')
